<template>
  <div class="error-card" v-if="error">
    <div class="error error-icon">
      <b-icon-exclamation-circle-fill variant="danger" />
    </div>
    <div class="error-text">
      <p class="mb-0 font-weight-bold" v-html="text"></p>
      <p class="mb-0" v-html="description"></p>
      <span class="error-link">
        <a :href="link">{{ linkText }}</a>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    error: { type: Boolean, required: false, default: false },
    link: { type: String, required: false, default: '' },
    linkText: { type: String, required: false, default: '' },
    text: { type: String, required: false, default: '' },
    description: { type: String, required: false, default: '' }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
.error-card {
  display: flex;
  border-radius: 10px;
  background: rgba(253, 207, 207, 0.99);
  .error {
    font-family: $nunito;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
  }
  .error-icon {
    font-size: 32px;
    padding: 14px 0 0 14px;
  }
  .error-text {
    padding: 15px;
  }
  .error-email {
    word-break: break-word;
    font-weight: bold;
  }
  .error-link {
    a {
      color: $secondary !important;
    }
    text-decoration-line: underline;
    font-family: $nunito;
  }
}
</style>
